export const findById = (id, list) => list.find(item => item.id === id);
export default {
  findById
};
